var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SchemaForm from './SchemaForm';

var Schema = (_temp2 = _class = function (_Component) {
    _inherits(Schema, _Component);

    function Schema() {
        var _temp, _this, _ret;

        _classCallCheck(this, Schema);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            editId: undefined,
            editName: undefined,
            expandId: undefined,
            expandName: undefined,
            dialog: {
                expanded: false,
                id: undefined
            }
        }, _this.componentDidUpdate = function (prevProps) {

            if (prevProps.expandId !== _this.props.expandId) {
                _this.setState({
                    expandId: _this.props.expandId
                });
            }
        }, _this.onSubmit = function (props) {

            if (_this.props.onSubmit) {
                _this.props.onSubmit(props);
            }
        }, _this.onChange = function (props) {

            if (_this.props.onChange) {
                _this.props.onChange(props);
            }
        }, _this.onSettings = function (id) {

            _this.setState({
                settings: id
            });

            if (_this.props.onSettings) {
                _this.props.onSettings(id);
            }
        }, _this.onAdd = function (props) {
            console.log('schema:onAdd', props);

            if (_this.props.onAdd) {
                _this.props.onAdd(props);
            }
        }, _this.onRemove = function (props) {
            console.log('schema:onRemove', props);

            if (_this.props.onRemove) {
                _this.props.onRemove(props);
            }
        }, _this.onEdit = function (props) {
            console.log('schema:onEdit', props);

            if (_this.props.onEdit) {
                _this.props.onEdit(props);
            }

            var id = props.id;


            var editId = undefined;
            var editName = undefined;

            if (id) {
                editId = id;
            }

            if (editId) {
                editName = editId.split('_');
                editName = editName.slice(-1).pop();
            }

            _this.setState({
                editId: editId,
                editName: editName
            });
        }, _this.onSave = function (props) {
            console.log('schema:onSave', props);

            if (_this.props.onSave) {
                _this.props.onSave(props);
            }

            var editId = undefined;
            var editName = undefined;

            _this.setState({
                editId: editId,
                editName: editName
            });
        }, _this.onExpand = function (id) {
            console.log('schema:onExpand', id);

            var expandId = void 0;
            var expandName = undefined;

            if (_this.props.onExpand) {
                expandId = _this.props.onExpand(id);
            } else {
                expandId = id;
            }

            if (expandId) {
                expandName = expandId.split('_');
                expandName = expandName.slice(-1).pop();
            }

            _this.setState({
                expandId: expandId,
                expandName: expandName
            });
        }, _this.onCollapse = function (id) {
            console.log('schema:onCollapse', id);

            var expandId = undefined;
            var expandName = undefined;

            if (_this.props.onCollapse) {
                expandId = _this.props.onCollapse(id);
            }

            if (expandId) {
                expandName = expandId.split('_');
                expandName = expandName.slice(-1).pop();
            }

            _this.setState({
                expandId: expandId,
                expandName: expandName
            });
        }, _this.onToggle = function (id) {
            console.log('schema:onToggle', id);

            var parentId = id.split('_');
            parentId.pop();
            parentId = parentId.join('_');

            var expandId = void 0;

            if (id && _this.state.expandId && _this.state.expandId.startsWith(id)) {
                expandId = parentId;
            } else {
                expandId = id;
            }

            if (_this.props.onToggle) {
                expandId = _this.props.onToggle(id);
            }

            _this.onExpand(expandId);
        }, _this.onDialog = function (dialog) {

            _this.setState({
                dialog: dialog
            });

            if (_this.props.onDialog) {
                _this.props.onDialog(dialog);
            }
        }, _this.onDialogChange = function (formData) {

            if (_this.props.onDialogChange) {
                _this.props.onDialogChange(_extends({}, _this.state.dialog, { formData: formData }));
            }

            _this.setState({
                dialog: _extends({}, _this.state.dialog, {
                    formData: formData
                })
            });
        }, _this.onUpload = function (upload) {

            if (_this.props.onUpload) {
                _this.props.onUpload(upload);
            }
        }, _this.getLanguage = function () {

            var language = void 0;

            if (_this.props.languages.length) {
                language = _this.props.languages[0];
            }

            if (_this.props.language) {
                language = _this.props.language;
            }

            return language;
        }, _this.getFormContext = function () {
            var _this$props = _this.props,
                formContext = _this$props.formContext,
                languages = _this$props.languages;

            var language = _this.getLanguage();

            var _this$state = _this.state,
                expandId = _this$state.expandId,
                expandName = _this$state.expandName,
                editId = _this$state.editId,
                editName = _this$state.editName,
                dialog = _this$state.dialog,
                settings = _this$state.settings;


            return _extends({}, formContext, {
                languages: languages,
                language: language,
                dialog: dialog,
                expandId: expandId,
                expandName: expandName,
                editId: editId,
                editName: editName,
                settings: settings,
                onEdit: _this.onEdit,
                onSave: _this.onSave,
                onAdd: _this.onAdd,
                onRemove: _this.onRemove,
                onExpand: _this.onExpand,
                onCollapse: _this.onCollapse,
                onToggle: _this.onToggle,
                onSettings: _this.onSettings,
                onUpload: _this.onUpload,
                onDialog: _this.onDialog,
                onDialogChange: _this.onDialogChange
                //            onSubmit: this.onSubmit,
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Schema.prototype.componentDidMount = function componentDidMount() {

        this.setState({
            expandId: this.props.expandId,
            dialog: this.props.dialog || {}
        });
    };

    /**
     * Called when form is submitted.
     * @return {function} this.props.onSubmit({ formData, errors })
     */

    /**
     * Called when content changes.
     * @return {function} this.props.onChange({ formData, errors })
     */

    /**
     * Called when layout settings is toggled.
     * @return {function} this.props.onSettings(id)
     */

    // ADD + REMOVE

    /**
     * Called when a editable layout is editing.
     * @return {function} this.props.onEdit(props)
     */

    /**
     * Called when a editable layout is saveed.
     * @return {function} this.props.onSave(props)
     */

    /**
     * Called when a collapsible layout is expanded.
     * @return {function} this.props.onExpand(id)
     */

    /**
     * Called when a collapsible layout is collapsed.
     * @return {function} this.props.onCollapse(id)
     */

    /**
     * Called when a collapsible layout is toggled.
     * @return {function} this.props.onToggle(id)
     */

    /**
     * Called when a dialog button is clicked. 
     * @return {function} this.props.onDialog({ id, type, schema, formData, onAdd, onRemove })
     */

    /**
     * Called when an upload button is clicked.
     * @return {function} this.props.onChange({ id, schema, formData, acceptedFiles, rejectedFiles, onAdd, onUpdate })
     */

    /**
     * Internal function for handling language and languages.
     */

    /**
     * Internal function for handling context.
     */

    Schema.prototype.render = function render() {
        var _props = this.props,
            schema = _props.schema,
            uiSchema = _props.uiSchema,
            formData = _props.formData;


        var formContext = this.getFormContext();

        return React.createElement(SchemaForm, _extends({}, this.props, { schema: schema, uiSchema: uiSchema, formData: formData, formContext: formContext, onChange: this.onChange, onSubmit: this.onSubmit }));
    };

    return Schema;
}(Component), _class.defaultProps = {
    schema: {},
    uiSchema: {},
    languages: ["en"],
    language: "en"
}, _temp2);
Schema.propTypes = process.env.NODE_ENV !== "production" ? {
    /** Schema */
    schema: PropTypes.object,
    /** uiSchema */
    uiSchema: PropTypes.object,
    /** An array of available languages for use in localizedString */
    languages: PropTypes.array,
    /** Current language */
    language: PropTypes.string,
    /**
     * Initial layout id that should be expanded.
     */
    expandId: PropTypes.string,
    /**
     * Function to handle onChange. Receives an object with { formData, ... }
     */
    onChange: PropTypes.func,
    /**
     * Function to handle upload buttons. Receives an object with { id, schema, formData, acceptedFiles, rejectedFiles, onAdd, onUpdate }
     */
    onUpload: PropTypes.func,
    /**
     * Function to handle dialog buttons. Receives an object with { id, type, schema, formData, onAdd, onRemove }
     */
    onDialog: PropTypes.func,
    /**
     * Called when a collapsible layout is toggled. Receives the id of the toggled layout. Should return the id to be expanded.
     */
    onToggle: PropTypes.func,
    /**
     * Called when a collapsible layout is expanded. Receives the id of the expanded layout. Should return the id to be expanded.
     */
    onExpand: PropTypes.func
} : {};


export default Schema;